module.exports = __webpack_public_path__ + "img/follow-us-3.d99b8b2e.jpg";